const budgetDriversEndpoints = {
  list: (companyId: string) => `/companies/${companyId}/budgeting/drivers`,
  detail: (companyId: string, id: number) => `/companies/${companyId}/budgeting/drivers/${id}`,
  order: (companyId: string) => `/companies/${companyId}/budgeting/drivers/order`
}

export default budgetDriversEndpoints
